var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraderone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6111 11.8889C12.6111 11.1227 12.9155 10.3879 13.4572 9.84614C13.999 9.30436 14.7338 9 15.5 9C16.2662 9 17.001 9.30436 17.5428 9.84614C18.0845 10.3879 18.3889 11.1227 18.3889 11.8889C18.3889 12.6551 18.0845 13.3899 17.5428 13.9316C17.001 14.4734 16.2662 14.7778 15.5 14.7778C14.7338 14.7778 13.999 14.4734 13.4572 13.9316C12.9155 13.3899 12.6111 12.6551 12.6111 11.8889ZM12.6111 16.2222C11.6534 16.2222 10.7349 16.6027 10.0577 17.2799C9.38046 17.9571 9 18.8756 9 19.8333C9 20.408 9.22827 20.9591 9.6346 21.3654C10.0409 21.7717 10.592 22 11.1667 22H19.8333C20.408 22 20.9591 21.7717 21.3654 21.3654C21.7717 20.9591 22 20.408 22 19.8333C22 18.8756 21.6195 17.9571 20.9423 17.2799C20.2651 16.6027 19.3466 16.2222 18.3889 16.2222H12.6111Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraderone);
export default __webpack_public_path__ + "static/media/Traderone.24762aaf216bb2d2bcc9ac3f96580e92.svg";
export { ForwardRef as ReactComponent };